import { useContext, useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { GridWidgetsContext } from '../GridWidgetsContext';

export const useWidgetResize = ({ id }) => {
  const { onResizeWidgetHeight } = useContext(GridWidgetsContext);

  const { height, ref } = useResizeDetector({
    handleWidth: false,
  });

  useEffect(() => {
    if (height) {
      onResizeWidgetHeight({ id, height });
    }
  }, [id, height]);

  return { ref };
};
